import React, { useEffect, useState, useRef } from "react";
import Swal2 from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import "../styles/payments.css";
import LoadingPopup from "../helpers/loading_component.js";
import SelectSearch from "react-select-search";
import { secretKey } from "../.././data";
import {
  PDFDownloadLink,
  Page,
  Font,
  Text,
  View,
  Document,
  Image,
  StyleSheet,
} from "@react-pdf/renderer";
import ReactPDF from "@react-pdf/renderer";

const MySwal = withReactContent(Swal2);

const AddClientQuestionnaire = (props) => {
  const [loading, setLoading] = useState(true);
  const [opt1, setOpt1] = useState("");
  const [opt2, setOpt2] = useState("");
  const [opt3, setOpt3] = useState("");
  const [opt4, setOpt4] = useState("");
  const [opt5, setOpt5] = useState("");
  const [opt6, setOpt6] = useState("");
  const [opt7, setOpt7] = useState("");
  const [opt8, setOpt8] = useState("");
  const [opt9, setOpt9] = useState("");
  const [opt10, setOpt10] = useState("");
  const [opt11, setOpt11] = useState("");
  const [opt12, setOpt12] = useState("");
  const [opt13, setOpt13] = useState("");
  const [opt14, setOpt14] = useState("");
  const [opt15, setOpt15] = useState("");
  const [opt16, setOpt16] = useState("");
  const [opt17, setOpt17] = useState("");
  const [opt18, setOpt18] = useState("");
  const [opt19, setOpt19] = useState("");
  const [opt20, setOpt20] = useState("");
  const [opt21, setOpt21] = useState("");
  const [opt22, setOpt22] = useState("");
  const [opt23, setOpt23] = useState("");
  const [opt24, setOpt24] = useState("");
  const [opt25, setOpt25] = useState("");
  const [opt26, setOpt26] = useState("");
  const [opt27, setOpt27] = useState("");
  const [opt28, setOpt28] = useState("");
  const [opt29, setOpt29] = useState("");

  const [optSKD1, setOptSKD1] = useState("");
  const [optSKD2, setOptSKD2] = useState("");
  const [optSKD3, setOptSKD3] = useState("");
  const [optSKD4, setOptSKD4] = useState("");
  const [optSKD5, setOptSKD5] = useState("");
  const [optSKD6, setOptSKD6] = useState("");
  const [optSKD7, setOptSKD7] = useState("");
  const [optSKD8, setOptSKD8] = useState("");
  const [optSKD9, setOptSKD9] = useState("");
  const [optSKD10, setOptSKD10] = useState("");
  const [optSKD11, setOptSKD11] = useState("");
  const [optSKD12, setOptSKD12] = useState("");
  const [optSKD13, setOptSKD13] = useState("");
  const [optSKD14, setOptSKD14] = useState("");
  const [optSKD15, setOptSKD15] = useState("");
  const [optSKD16, setOptSKD16] = useState("");
  const [optSKD17, setOptSKD17] = useState("");
  const [optSKD18, setOptSKD18] = useState("");
  const [optSKD19, setOptSKD19] = useState("");
  const [optSKD20, setOptSKD20] = useState("");
  const [optSKD21, setOptSKD21] = useState("");

  const [clientQuest, setClientQuest] = useState([]);
  const [clientsQuestData, setClientsQuestData] = useState([]);
  const [mode, setMode] = useState("add");

  const validatePayment = (e) => {
    if (true) {
      return true;
    } else {
      return false;
    }
  };

  const fetchClients = async () => {
    var body = {
      id: +props.client.id,
    };

    await fetch("https://apidevkppp.ftpeople.pl/getClientsQuestionnairesId", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: secretKey,
      },
      body: JSON.stringify(body),
    })
      .then((response) => response.json())
      .then((data) => {
        setClientsQuestData(data);
        var clientQuest = data.filter(
          (el) => +el.clientId === +props.client.id
        )[0];
        setClientQuest(clientQuest);
        if (data.filter((el) => +el.clientId === +props.client.id).length > 0) {
          setMode("view");
        }

        props.logClientAction(
          "Otwarto ankietę dla sprawy " + props.client.petitioner,
          props.client.id
        );

        setLoading(false);
      })
      .catch((error) => {});
  };

  const getData = async () => {
    setLoading(true);
    fetchClients();
  };

  useEffect(() => {
    getData();
  }, []);

  const handleOpt1Change = (e) => {
    setOpt1(e.target.value);
  };

  const handleOpt2Change = (e) => {
    setOpt2(e.target.value);
  };

  const handleOpt3Change = (e) => {
    setOpt3(e.target.value);
  };

  const handleOpt4Change = (e) => {
    setOpt4(e.target.value);
  };

  const handleOpt5Change = (e) => {
    setOpt5(e.target.value);
  };

  const handleOpt6Change = (e) => {
    setOpt6(e.target.value);
  };

  const handleOpt7Change = (e) => {
    setOpt7(e.target.value);
  };

  const handleOpt8Change = (e) => {
    setOpt8(e.target.value);
  };

  const handleOpt9Change = (e) => {
    setOpt9(e.target.value);
  };

  const handleOpt10Change = (e) => {
    setOpt10(e.target.value);
  };

  const handleOpt11Change = (e) => {
    setOpt11(e.target.value);
  };

  const handleOpt12Change = (e) => {
    setOpt12(e.target.value);
  };

  const handleOpt13Change = (e) => {
    setOpt13(e.target.value);
  };

  const handleOpt14Change = (e) => {
    setOpt14(e.target.value);
  };

  const handleOpt15Change = (e) => {
    setOpt15(e.target.value);
  };

  const handleOpt16Change = (e) => {
    setOpt16(e.target.value);
  };

  const handleOpt17Change = (e) => {
    setOpt17(e.target.value);
  };

  const handleOpt18Change = (e) => {
    setOpt18(e.target.value);
  };

  const handleOpt19Change = (e) => {
    setOpt19(e.target.value);
  };

  const handleOpt20Change = (e) => {
    setOpt20(e.target.value);
  };

  const handleOpt21Change = (e) => {
    setOpt21(e.target.value);
  };

  const handleOpt22Change = (e) => {
    setOpt22(e.target.value);
  };

  const handleOpt23Change = (e) => {
    setOpt23(e.target.value);
  };

  const handleOpt24Change = (e) => {
    setOpt24(e.target.value);
  };

  const handleOpt25Change = (e) => {
    setOpt25(e.target.value);
  };

  const handleOpt26Change = (e) => {
    setOpt26(e.target.value);
  };

  const handleOpt27Change = (e) => {
    setOpt27(e.target.value);
  };

  const handleOpt28Change = (e) => {
    setOpt28(e.target.value);
  };

  const handleOpt29Change = (e) => {
    setOpt29(e.target.value);
  };

  const handleEditQuest = (e) => {
    setLoading(true);
    setMode("edit");
    setOpt1(clientQuest.opt1);
    setOpt2(clientQuest.opt2);
    setOpt3(clientQuest.opt3);
    setOpt4(clientQuest.opt4);
    setOpt5(clientQuest.opt5);
    setOpt6(clientQuest.opt6);
    setOpt7(clientQuest.opt7);
    setOpt8(clientQuest.opt8);
    setOpt9(clientQuest.opt9);
    setOpt10(clientQuest.opt10);
    setOpt11(clientQuest.opt11);
    setOpt12(clientQuest.opt12);
    setOpt13(clientQuest.opt13);
    setOpt14(clientQuest.opt14);
    setOpt15(clientQuest.opt15);
    setOpt16(clientQuest.opt16);
    setOpt17(clientQuest.opt17);
    setOpt18(clientQuest.opt18);
    setOpt19(clientQuest.opt19);
    setOpt20(clientQuest.opt20);
    setOpt21(clientQuest.opt21);
    setOpt22(clientQuest.opt22);
    setOpt23(clientQuest.opt23);
    setOpt24(clientQuest.opt24);
    setOpt25(clientQuest.opt25);
    setOpt26(clientQuest.opt26);
    setOpt27(clientQuest.opt27);
    setOpt28(clientQuest.opt28);
    setOpt29(clientQuest.opt29);

    setOptSKD1(clientQuest.optSKD1);
    setOptSKD2(clientQuest.optSKD2);
    setOptSKD3(clientQuest.optSKD3);
    setOptSKD4(clientQuest.optSKD4);
    setOptSKD5(clientQuest.optSKD5);
    setOptSKD6(clientQuest.optSKD6);
    setOptSKD7(clientQuest.optSKD7);
    setOptSKD8(clientQuest.optSKD8);
    setOptSKD9(clientQuest.optSKD9);
    setOptSKD10(clientQuest.optSKD10);
    setOptSKD11(clientQuest.optSKD11);
    setOptSKD12(clientQuest.optSKD12);
    setOptSKD13(clientQuest.optSKD13);
    setOptSKD14(clientQuest.optSKD14);
    setOptSKD15(clientQuest.optSKD15);
    setOptSKD16(clientQuest.optSKD16);
    setOptSKD17(clientQuest.optSKD17);
    setOptSKD18(clientQuest.optSKD18);
    setOptSKD19(clientQuest.optSKD19);
    setOptSKD20(clientQuest.optSKD20);
    setOptSKD21(clientQuest.optSKD21);

    setLoading(false);
  };

  const addQuest = async () => {
    var data = [
      {
        id: new Date().valueOf(),
        clientId: props.client.id,
        opt1: opt1,
        opt2: opt2,
        opt3: opt3,
        opt4: opt4,
        opt5: opt5,
        opt6: opt6,
        opt7: opt7,
        opt8: opt8,
        opt9: opt9,
        opt10: opt10,
        opt11: opt11,
        opt12: opt12,
        opt13: opt13,
        opt14: opt14,
        opt15: opt15,
        opt16: opt16,
        opt17: opt17,
        opt18: opt18,
        opt19: opt19,
        opt20: opt20,
        opt21: opt21,
        opt22: opt22,
        opt23: opt23,
        opt24: opt24,
        opt25: opt25,
        opt26: opt26,
        opt27: opt27,
        opt28: opt28,
        opt29: opt29,
      },
    ];

    await props.clientsQuestSheetData.addRows(data);

    props.logClientAction(
      "Dodano ankietę do sprawy " + props.client.petitioner,
      props.client.id
    );

    MySwal.fire({
      icon: "success",
      title: "Dodano",
      text: "ankietę do sprawy",
    }).then(async (result) => {
      props.close();
    });
  };

  const editQuest = async () => {
    var rows = await props.clientsQuestSheetData.getRows();
    var toEditData = rows.filter((el) => el.clientId === props.client.id)[0];

    toEditData.opt1 = opt1;
    toEditData.opt2 = opt2;
    toEditData.opt3 = opt3;
    toEditData.opt4 = opt4;
    toEditData.opt5 = opt5;
    toEditData.opt6 = opt6;
    toEditData.opt7 = opt7;
    toEditData.opt8 = opt8;
    toEditData.opt9 = opt9;
    toEditData.opt10 = opt10;
    toEditData.opt11 = opt11;
    toEditData.opt12 = opt12;
    toEditData.opt13 = opt13;
    toEditData.opt14 = opt14;
    toEditData.opt15 = opt15;
    toEditData.opt16 = opt16;
    toEditData.opt17 = opt17;
    toEditData.opt18 = opt18;
    toEditData.opt19 = opt19;
    toEditData.opt20 = opt20;
    toEditData.opt21 = opt21;
    toEditData.opt22 = opt22;
    toEditData.opt23 = opt23;
    toEditData.opt24 = opt24;
    toEditData.opt25 = opt25;
    toEditData.opt26 = opt26;
    toEditData.opt27 = opt27;
    toEditData.opt28 = opt28;
    toEditData.opt29 = opt29;

    await toEditData.save();

    props.logClientAction(
      "Edytowano ankietę do sprawy " + props.client.petitioner,
      props.client.id
    );

    MySwal.fire({
      icon: "success",
      title: "Edytowano",
      text: "ankietę do sprawy",
    }).then(async (result) => {
      props.close();
    });
  };

  Font.register({
    family: "Roboto",
    src: "https://cdnjs.cloudflare.com/ajax/libs/ink/3.1.10/fonts/Roboto/roboto-light-webfont.ttf",
  });

  const styles = StyleSheet.create({
    body: {
      paddingTop: 35,
      paddingBottom: 65,
      paddingHorizontal: 35,
    },
    title: {
      fontSize: 24,
      textAlign: "center",
      fontFamily: "Roboto",
      marginBottom: 10,
    },
    author: {
      fontSize: 12,
      textAlign: "center",
      marginBottom: 40,
    },
    subtitle: {
      fontSize: 18,
      margin: 12,
      fontFamily: "Roboto",
    },
    text: {
      margin: 12,
      fontSize: 14,
      textAlign: "justify",
      fontFamily: "Roboto",
    },
    image: {
      marginVertical: 15,
      marginHorizontal: 100,
    },
    header: {
      fontSize: 12,
      marginBottom: 20,
      textAlign: "center",
      color: "grey",
    },
    pageNumber: {
      position: "absolute",
      fontSize: 8,
      bottom: 30,
      left: 0,
      right: 0,
      textAlign: "center",
      color: "grey",
    },
    table: {
      display: "table",
      width: "auto",
      borderStyle: "solid",
      borderWidth: 1,
      borderRightWidth: 0,
      borderBottomWidth: 0,
      fontFamily: "Roboto",
      verticalAlign: "center",
    },
    tableRow: {
      margin: "auto",
      flexDirection: "row",
      verticalAlign: "center",
    },
    tableCol: {
      width: "60%",
      borderStyle: "solid",
      borderWidth: 1,
      borderLeftWidth: 0,
      borderTopWidth: 0,
      verticalAlign: "center",
    },
    tableCol2: {
      width: "40%",
      borderStyle: "solid",
      borderWidth: 1,
      borderLeftWidth: 0,
      borderTopWidth: 0,
      verticalAlign: "center",
    },
    tableCell: {
      marginVertical: "auto",
      verticalAlign: "center",
      textAlign: "left",
      fontSize: 8,
      padding: 5,
    },
  });

  const MyDocument = () =>
    clientQuest !== undefined ? (
      <>
        <Document>
          <Page style={styles.body}>
            <Text style={styles.title} fixed>
              {props.client.petitioner} - ANKIETA KLIENTA
            </Text>
            <View style={styles.table}>
              <View style={styles.tableRow}>
                <View style={styles.tableCol}>
                  <Text style={styles.tableCell}>
                    Czy kredyt został przeznaczony na spłatę innych zobowiązań
                    finansowych? (np. inne kredyty hipoteczne, inne kredyty
                    gotówkowe){" "}
                  </Text>
                </View>
                <View style={styles.tableCol2}>
                  <Text style={styles.tableCell}>{clientQuest.opt1}</Text>
                </View>
              </View>
              {clientQuest.opt1 === "TAK" ? (
                <>
                  <View style={styles.tableRow}>
                    <View style={styles.tableCol}>
                      <Text style={styles.tableCell}>
                        Waluty tych kredytów/pożyczek oraz ich przeznaczenie
                      </Text>
                    </View>
                    <View style={styles.tableCol2}>
                      <Text style={styles.tableCell}>{clientQuest.opt2}</Text>
                    </View>
                  </View>
                </>
              ) : (
                ""
              )}

              <View style={styles.tableRow}>
                <View style={styles.tableCol}>
                  <Text style={styles.tableCell}>
                    Cele mieszkaniowe (np. własne, dla rodziny)
                  </Text>
                </View>
                <View style={styles.tableCol2}>
                  <Text style={styles.tableCell}>{clientQuest.opt3}</Text>
                </View>
              </View>
              {clientQuest.opt3 === "TAK" ? (
                <>
                  <View style={styles.tableRow}>
                    <View style={styles.tableCol}>
                      <Text style={styles.tableCell}>
                        Jakie cele mieszkaniowe
                      </Text>
                    </View>
                    <View style={styles.tableCol2}>
                      <Text style={styles.tableCell}>{clientQuest.opt4}</Text>
                    </View>
                  </View>
                </>
              ) : (
                ""
              )}

              <View style={styles.tableRow}>
                <View style={styles.tableCol}>
                  <Text style={styles.tableCell}>
                    Czy mieszkali Pańśtwo w kredytowanej nieruchomości?
                  </Text>
                </View>
                <View style={styles.tableCol2}>
                  <Text style={styles.tableCell}>{clientQuest.opt20}</Text>
                </View>
              </View>
              {clientQuest.opt20 === "TAK" ? (
                <>
                  <View style={styles.tableRow}>
                    <View style={styles.tableCol}>
                      <Text style={styles.tableCell}>W jakim okresie?</Text>
                    </View>
                    <View style={styles.tableCol2}>
                      <Text style={styles.tableCell}>{clientQuest.opt21}</Text>
                    </View>
                  </View>
                </>
              ) : (
                ""
              )}

              <View style={styles.tableRow}>
                <View style={styles.tableCol}>
                  <Text style={styles.tableCell}>Inne cele konsumpcyjne?</Text>
                </View>
                <View style={styles.tableCol2}>
                  <Text style={styles.tableCell}>{clientQuest.opt5}</Text>
                </View>
              </View>
              {clientQuest.opt5 === "TAK" ? (
                <>
                  <View style={styles.tableRow}>
                    <View style={styles.tableCol}>
                      <Text style={styles.tableCell}>Jakie?</Text>
                    </View>
                    <View style={styles.tableCol2}>
                      <Text style={styles.tableCell}>{clientQuest.opt6}</Text>
                    </View>
                  </View>
                </>
              ) : (
                ""
              )}

              <View style={styles.tableRow}>
                <View style={styles.tableCol}>
                  <Text style={styles.tableCell}>
                    Działalność gospodarcza - czy była prowadzona lub
                    zarejestrowana w kredytowanej nieruchomości?{" "}
                  </Text>
                </View>
                <View style={styles.tableCol2}>
                  <Text style={styles.tableCell}>{clientQuest.opt7}</Text>
                </View>
              </View>
              {clientQuest.opt7 === "TAK" ? (
                <>
                  <View style={styles.tableRow}>
                    <View style={styles.tableCol}>
                      <Text style={styles.tableCell}>W jakim okresie?</Text>
                    </View>
                    <View style={styles.tableCol2}>
                      <Text style={styles.tableCell}>{clientQuest.opt8}</Text>
                    </View>
                  </View>
                  <View style={styles.tableRow}>
                    <View style={styles.tableCol}>
                      <Text style={styles.tableCell}>
                        Jaki to był rodzaj działalności?
                      </Text>
                    </View>
                    <View style={styles.tableCol2}>
                      <Text style={styles.tableCell}>{clientQuest.opt9}</Text>
                    </View>
                  </View>
                  <View style={styles.tableRow}>
                    <View style={styles.tableCol}>
                      <Text style={styles.tableCell}>
                        Na czym dokładnie polegała działalność? Czy była
                        zarejestrowana wyłącznie do celów ewidencyjnych czy
                        rzeczywiście prowadzona w kredytowanej nieruchomości?
                      </Text>
                    </View>
                    <View style={styles.tableCol2}>
                      <Text style={styles.tableCell}>{clientQuest.opt22}</Text>
                    </View>
                  </View>
                </>
              ) : (
                ""
              )}

              <View style={styles.tableRow}>
                <View style={styles.tableCol}>
                  <Text style={styles.tableCell}>
                    Czy lokal był wynajmowany?
                  </Text>
                </View>
                <View style={styles.tableCol2}>
                  <Text style={styles.tableCell}>{clientQuest.opt10}</Text>
                </View>
              </View>
              {clientQuest.opt10 === "TAK" ? (
                <>
                  <View style={styles.tableRow}>
                    <View style={styles.tableCol}>
                      <Text style={styles.tableCell}>W jakim okresie?</Text>
                    </View>
                    <View style={styles.tableCol2}>
                      <Text style={styles.tableCell}>{clientQuest.opt11}</Text>
                    </View>
                  </View>
                </>
              ) : (
                ""
              )}

              <View style={styles.tableRow}>
                <View style={styles.tableCol}>
                  <Text style={styles.tableCell}>
                    Czy jest rozdzielność majątkowa?
                  </Text>
                </View>
                <View style={styles.tableCol2}>
                  <Text style={styles.tableCell}>{clientQuest.opt12}</Text>
                </View>
              </View>
              {clientQuest.opt12 === "TAK" ? (
                <>
                  <View style={styles.tableRow}>
                    <View style={styles.tableCol}>
                      <Text style={styles.tableCell}>Od kiedy?</Text>
                    </View>
                    <View style={styles.tableCol2}>
                      <Text style={styles.tableCell}>{clientQuest.opt13}</Text>
                    </View>
                  </View>
                </>
              ) : (
                ""
              )}

              <View style={styles.tableRow}>
                <View style={styles.tableCol}>
                  <Text style={styles.tableCell}>
                    Kto faktycznie spłacał kredyt? (dot. sytuacji, gdy wśród
                    jest kilku kredytobiorców)
                  </Text>
                </View>
                <View style={styles.tableCol2}>
                  <Text style={styles.tableCell}>{clientQuest.opt14}</Text>
                </View>
              </View>
              {clientQuest.opt14 === "JEDEN KREDYTOBIORCA" ? (
                <>
                  <View style={styles.tableRow}>
                    <View style={styles.tableCol}>
                      <Text style={styles.tableCell}>
                        Imię i nazwisko kredytobiorcy
                      </Text>
                    </View>
                    <View style={styles.tableCol2}>
                      <Text style={styles.tableCell}>{clientQuest.opt15}</Text>
                    </View>
                  </View>
                </>
              ) : (
                ""
              )}

              <View style={styles.tableRow}>
                <View style={styles.tableCol}>
                  <Text style={styles.tableCell}>
                    Czy jest wspólność majątkowa?
                  </Text>
                </View>
                <View style={styles.tableCol2}>
                  <Text style={styles.tableCell}>{clientQuest.opt23}</Text>
                </View>
              </View>
              {clientQuest.opt23 === "TAK" ? (
                <>
                  <View style={styles.tableRow}>
                    <View style={styles.tableCol}>
                      <Text style={styles.tableCell}>Od kiedy?</Text>
                    </View>
                    <View style={styles.tableCol2}>
                      <Text style={styles.tableCell}>{clientQuest.opt24}</Text>
                    </View>
                  </View>
                </>
              ) : (
                ""
              )}

              <View style={styles.tableRow}>
                <View style={styles.tableCol}>
                  <Text style={styles.tableCell}>
                    Czy pracowali Państwo w banku/instytucji finansowej?
                  </Text>
                </View>
                <View style={styles.tableCol2}>
                  <Text style={styles.tableCell}>{clientQuest.opt16}</Text>
                </View>
              </View>
              {clientQuest.opt16 === "TAK" ? (
                <>
                  <View style={styles.tableRow}>
                    <View style={styles.tableCol}>
                      <Text style={styles.tableCell}>W jakim okresie?</Text>
                    </View>
                    <View style={styles.tableCol2}>
                      <Text style={styles.tableCell}>{clientQuest.opt17}</Text>
                    </View>
                  </View>
                  <View style={styles.tableRow}>
                    <View style={styles.tableCol}>
                      <Text style={styles.tableCell}>
                        Jakie były obowiązki? Czy była powiązana z kredytami
                        wal. do waluty obcej?
                      </Text>
                    </View>
                    <View style={styles.tableCol2}>
                      <Text style={styles.tableCell}>{clientQuest.opt25}</Text>
                    </View>
                  </View>
                </>
              ) : (
                ""
              )}

              <View style={styles.tableRow}>
                <View style={styles.tableCol}>
                  <Text style={styles.tableCell}>
                    W jakiej walucie spłacany był kredyt?
                  </Text>
                </View>
                <View style={styles.tableCol2}>
                  <Text style={styles.tableCell}>{clientQuest.opt18}</Text>
                </View>
              </View>
              {clientQuest.opt18 === "CHF" ? (
                <>
                  <View style={styles.tableRow}>
                    <View style={styles.tableCol}>
                      <Text style={styles.tableCell}>
                        Od kiedy kredyt był spłacany w CHF?
                      </Text>
                    </View>
                    <View style={styles.tableCol2}>
                      <Text style={styles.tableCell}>{clientQuest.opt19}</Text>
                    </View>
                  </View>
                </>
              ) : (
                ""
              )}
            </View>
            <Text
              style={styles.pageNumber}
              render={({ pageNumber, totalPages }) =>
                `Wygenerowano w systemie KPPP WORKFLOW - Kancelaria Radcy Prawnego Mateusz Płudowski`
              }
              fixed
            />
          </Page>
        </Document>
      </>
    ) : (
      ""
    );

  const createPDF =
    clientQuest !== undefined ? (
      <>
        <PDFDownloadLink
          className="pdfButt"
          document={<MyDocument />}
          fileName={clientQuest.id + "_ankieta.pdf"}
        >
          {" "}
          POBIERZ PDF{" "}
        </PDFDownloadLink>
      </>
    ) : (
      ""
    );

  return (
    <div className="mainContainerAddClient">
      {loading ? (
        <LoadingPopup />
      ) : (
        <>
          <div style={{ marginBottom: "5vh" }} className="closeBox">
            <button className="closeClientButton" onClick={props.close}>
              X
            </button>
          </div>
          {mode === "view" ? (
            <>
              <div className="boxAdditionalFunFlex">{createPDF}</div>
              <>
                {props.client.type === "sankcja kredytu darmowego" ? (
                  <>
                    <table id="detailClientTable" className="clients_table">
                      <>
                        <tr>
                          <td>
                            Czy środki z umowy przeznaczono na cele
                            konsumpcyjne?
                          </td>
                          <td>{clientQuest.optSKD1}</td>
                        </tr>
                        <tr>
                          <td>Jakie cele konsumpcyjne?</td>
                          <td>{clientQuest.optSKD2}</td>
                        </tr>
                        <tr>
                          <td>
                            Na co przeznaczono poprzednie zobowiązania
                            finansowe?
                          </td>
                          <td>{clientQuest.optSKD4}</td>
                        </tr>
                        <tr>
                          <td>
                            Czy środki z umowy przeznaczono na cele
                            mieszkaniowe?
                          </td>
                          <td>{clientQuest.optSKD5}</td>
                        </tr>
                        <tr>
                          <td>Jakie cele mieszkaniowe?</td>
                          <td>{clientQuest.optSKD6}</td>
                        </tr>
                        <tr>
                          <td>Czy środki z umowy przeznaczono na inne cele?</td>
                          <td>{clientQuest.optSKD7}</td>
                        </tr>
                        <tr>
                          <td>Proszę o szczegółową informację</td>
                          <td>{clientQuest.optSKD8}</td>
                        </tr>
                        <tr>
                          <td>
                            Jeżeli umowa finansowała wcześniejsze zobowiązania
                            (kredyt/pożyczka konsolidacyjna), prosimy wskazać,
                            czy były one powiązane z prowadzeniem działalności
                            gospodarczej?
                          </td>
                          <td>{clientQuest.optSKD9}</td>
                        </tr>
                        <tr>
                          <td>
                            Czy w momencie zawierania umowy któryś z
                            kredytobiorców/pożyczkobiorców prowadził działalność
                            gospodarczą?
                          </td>
                          <td>{clientQuest.optSKD10}</td>
                        </tr>
                        <tr>
                          <td>
                            Czy umowa została przez Państwa spłacona w całości?
                          </td>
                          <td>{clientQuest.optSKD11}</td>
                        </tr>
                        <tr>
                          <td>Kiedy została spłacona?</td>
                          <td>{clientQuest.optSKD12}</td>
                        </tr>
                        <tr>
                          <td>
                            Czy otrzymali Państwo od Kredytodawcy zwrot części
                            prowizji/innych kosztów w związku z wcześniejszą
                            spłatą umowy?
                          </td>
                          <td>{clientQuest.optSKD13}</td>
                        </tr>
                        <tr>
                          <td>
                            W jakiej wysokości została zwrócona prowizja i inne
                            koszty?
                          </td>
                          <td>{clientQuest.optSKD14}</td>
                        </tr>
                        <tr>
                          <td>
                            Czy kredytobiorca ogłosił upadłość konsumencką?
                          </td>
                          <td>{clientQuest.optSKD15}</td>
                        </tr>
                        <tr>
                          <td>
                            Czy w okresie trwania umowy doszło do zwolnienia
                            któregokolwiek z Kredytobiorców/Pożyczkobiorców z
                            długu?
                          </td>
                          <td>{clientQuest.optSKD16}</td>
                        </tr>
                        <tr>
                          <td>
                            Czy w okresie trwania umowy doszło do przystąpienia
                            do długu przez innego Kredytobiorcę/Pożyczkobiorcę?
                          </td>
                          <td>{clientQuest.optSKD17}</td>
                        </tr>
                        <tr>
                          <td>
                            Czy w trakcie trwania umowy nastąpił zgon
                            któregokolwiek z Kredytobiorców/Pożyczkobiorców?
                          </td>
                          <td>{clientQuest.optSKD18}</td>
                        </tr>
                        <tr>
                          <td>
                            W przypadku, gdy umowa została zawarta przez
                            Kredytobiorców/Pożyczkobiorców pozostających w
                            związku małżeńskim, prosimy wskazać czy pozostawali
                            w ustroju wspólności majątkowej?
                          </td>
                          <td>{clientQuest.optSKD19}</td>
                        </tr>
                        <tr>
                          <td>Od kiedy?</td>
                          <td>{clientQuest.optSKD20}</td>
                        </tr>
                        <tr>
                          <td>
                            W przypadku, gdy umowa została zawarta przez
                            Kredytobiorców/Pożyczkobiorców pozostających w
                            związku małżeńskim, prosimy wskazać czy ustanowiono
                            rozdzielność majątkową?
                          </td>
                          <td>{clientQuest.optSKD22}</td>
                        </tr>
                        <tr>
                          <td>Od kiedy?</td>
                          <td>{clientQuest.optSKD23}</td>
                        </tr>
                        <tr>
                          <td>Kto faktycznie spłacał kredyt/pożyczkę?</td>
                          <td>{clientQuest.optSKD21}</td>
                        </tr>
                      </>
                    </table>
                  </>
                ) : (
                  <>
                    <table id="detailClientTable" className="clients_table">
                      <>
                        <tr>
                          <td>
                            Czy kredyt został przeznaczony na spłatę innych
                            zobowiązań finansowych? (np. inne kredyty
                            hipoteczne, inne kredyty gotówkowe)
                          </td>
                          <td>{clientQuest.opt1}</td>
                        </tr>
                        {clientQuest.opt1 === "TAK" ? (
                          <>
                            <tr>
                              <td>
                                Waluty tych kredytów/pożyczek oraz ich
                                przeznaczenie
                              </td>
                              <td>{clientQuest.opt2}</td>
                            </tr>
                          </>
                        ) : (
                          ""
                        )}
                        <tr>
                          <td>Cele mieszkaniowe (np. własne, dla rodziny)</td>
                          <td>{clientQuest.opt3}</td>
                        </tr>
                        {clientQuest.opt3 === "TAK" ? (
                          <>
                            <tr>
                              <td>Jakie cele mieszkaniowe</td>
                              <td>{clientQuest.opt4}</td>
                            </tr>
                          </>
                        ) : (
                          ""
                        )}
                        <tr>
                          <td>
                            Czy mieszkali Pańśtwo w kredytowanej nieruchomości?
                          </td>
                          <td>{clientQuest.opt20}</td>
                        </tr>
                        {clientQuest.opt20 === "TAK" ? (
                          <>
                            <tr>
                              <td>W jakim okresie?</td>
                              <td>{clientQuest.opt21}</td>
                            </tr>
                          </>
                        ) : (
                          ""
                        )}
                        <tr>
                          <td>Inne cele konsumpcyjne</td>
                          <td>{clientQuest.opt5}</td>
                        </tr>
                        {clientQuest.opt5 === "TAK" ? (
                          <>
                            <tr>
                              <td>Jakie</td>
                              <td>{clientQuest.opt6}</td>
                            </tr>
                          </>
                        ) : (
                          ""
                        )}
                        <tr>
                          <td>
                            Działalność gospodarcza - czy była prowadzona lub
                            zarejestrowana w kredytowanej nieruchomości?
                          </td>
                          <td>{clientQuest.opt7}</td>
                        </tr>
                        {clientQuest.opt7 === "TAK" ? (
                          <>
                            <tr>
                              <td>W jakim okresie?</td>
                              <td>{clientQuest.opt8}</td>
                            </tr>
                            <tr>
                              <td>Jaki to był rodzaj działalności?</td>
                              <td>{clientQuest.opt9}</td>
                            </tr>
                            <tr>
                              <td>
                                Na czym dokładnie polegała działalność? Czy była
                                zarejestrowana wyłącznie do celów ewidencyjnych
                                czy rzeczywiście prowadzona w kredytowanej
                                nieruchomości?
                              </td>
                              <td>{clientQuest.opt22}</td>
                            </tr>
                          </>
                        ) : (
                          ""
                        )}
                        <tr>
                          <td>Czy lokal był wynajmowany?</td>
                          <td>{clientQuest.opt10}</td>
                        </tr>
                        {clientQuest.opt10 === "TAK" ? (
                          <>
                            <tr>
                              <td>W jakim okresie?</td>
                              <td>{clientQuest.opt11}</td>
                            </tr>
                          </>
                        ) : (
                          ""
                        )}
                        <tr>
                          <td>Czy jest rozdzielność majątkowa?</td>
                          <td>{clientQuest.opt12}</td>
                        </tr>
                        {clientQuest.opt12 === "TAK" ? (
                          <>
                            <tr>
                              <td>Od kiedy?</td>
                              <td>{clientQuest.opt13}</td>
                            </tr>
                          </>
                        ) : (
                          ""
                        )}
                        <tr>
                          <td>
                            Kto faktycznie spłacał kredyt? (dot. sytuacji, gdy
                            wśród jest kilku kredytobiorców)
                          </td>
                          <td>{clientQuest.opt14}</td>
                        </tr>
                        {clientQuest.opt14 === "JEDEN KREDYTOBIORCA" ? (
                          <>
                            <tr>
                              <td>Imię i nazwisko kredytobiorcy</td>
                              <td>{clientQuest.opt15}</td>
                            </tr>
                          </>
                        ) : (
                          ""
                        )}
                        <tr>
                          <td>Czy jest wspólność majątkowa?</td>
                          <td>{clientQuest.opt23}</td>
                        </tr>
                        {clientQuest.opt23 === "TAK" ? (
                          <>
                            <tr>
                              <td>Od kiedy?</td>
                              <td>{clientQuest.opt24}</td>
                            </tr>
                          </>
                        ) : (
                          ""
                        )}
                        <tr>
                          <td>
                            Czy pracowali Państwo w banku/instytucji finansowej?
                          </td>
                          <td>{clientQuest.opt16}</td>
                        </tr>
                        {clientQuest.opt16 === "TAK" ? (
                          <>
                            <tr>
                              <td>W jakim okresie?</td>
                              <td>{clientQuest.opt17}</td>
                            </tr>
                            <tr>
                              <td>
                                Jakie były obowiązki? Czy była powiązana z
                                kredytami wal. do waluty obcej?
                              </td>
                              <td>{clientQuest.opt25}</td>
                            </tr>
                          </>
                        ) : (
                          ""
                        )}
                        <tr>
                          <td>W jakiej walucie był spłacany kredyt?</td>
                          <td>{clientQuest.opt18}</td>
                        </tr>
                        {clientQuest.opt18 === "CHF" ? (
                          <>
                            <tr>
                              <td>Od kiedy kredyt był spłacany w CHF?</td>
                              <td>{clientQuest.opt19}</td>
                            </tr>
                          </>
                        ) : (
                          ""
                        )}
                      </>
                    </table>
                  </>
                )}

                {true ? (
                  ""
                ) : (
                  <div className="saveBoxAP">
                    <button
                      className="paymentMenuButton"
                      onClick={handleEditQuest}
                    >
                      Edytuj
                    </button>
                  </div>
                )}
              </>
            </>
          ) : (
            <>
              <span>Klient nie uzupełnił jeszcze ankiety dla sprawy.</span>
            </>
          )}
        </>
      )}
    </div>
  );
};

export default AddClientQuestionnaire;
